import { styled } from "@mui/material/styles";
import DividerBase from "@mui/material/Divider";

export const Divider = styled(DividerBase)`
  background-color: ${({ theme }) => theme.colors.border[1]};
`;
